import { LabelsType } from './types';

export const DEFAULT_LABELS = {
    startAmount: 'Startbelopp',
    monthlyDeposit: 'Månadssparande',
    savingsPeriod: 'Spartid',
    selectProduct: 'Välj en produkt',
    orSelectProduct: 'Eller välj en produkt',
    customInterestRateHeader: 'Ange egen ränta',
    customInterestRate: 'Egen ränta',
    invalidInterestRate: 'Ogiltig ränta',
    summaryCalculationText:
        'Du kommer att spara <span class="bold">{{total}} kr</span> om <span class="bold">{{years}} år</span> – varav <span class="bold highlight">{{interest}} kr</span> är intjänad ränta',
    savingsGrowthOverTime: 'Sparutveckling över tid',
    graphDesc: 'Graf som visar hur ränta-på-ränta ökar och insatt belopp över tid.',
    showGraphButton: 'Visa graf',
    showTableButton: 'Visa tabell',
    depositAmount: 'Insatt belopp',
    finalAmount: 'Slutsumma',
    variable: 'Rörlig',
    fixed: 'Fast',
    rate: 'ränta',
    year: 'år',
    years: 'år',
    currency: 'kr',
    today: 'Idag',
};

export const getLabel = (labels: LabelsType, key: keyof LabelsType, replacements?: Record<string, string | number>) => {
    const label = labels?.[key] || DEFAULT_LABELS[key];
    let result = label;

    if (replacements) {
        Object.entries(replacements).forEach(([placeholder, value]) => {
            const regex = new RegExp(`{{\\s*${placeholder}\\s*}}`, 'g');
            result = result.replace(regex, String(value));
        });
    }

    return result.replace(/\s*style="[^"]*"/g, '');
};
